import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import Layout from '@src/pages/layout'
import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
// import OrdersPageTemplate from '@src/quince-site-integrated/src/templates/Account/my-orders-and-returns/'
import OrdersPageTemplate from '@src/quince-site-integrated/src/templates/Account/my-orders-and-returns'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'

// add this to prevent suspense error due to usage of useStatsigClient hook in my-orders-and-returns for exp

export const getServerSideProps = (async ctx => {
  const pathName = PAGE_PATH.MY_ORDERS_RETURNS

  const serverSideBaseProps = await getServerSideBaseProps(
    ctx,
    pathName,
    // new URLSearchParams(ctx.query as Record<string, string>)
  )
  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function PageAccountsMyOrdersReturns(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <Layout {...props}>{<OrdersPageTemplate data={props.pageData} location={{ search: props.searchParams }} />}</Layout>
  )
}
